import serviceCalls from "../services/serviceCalls";
import { toastr } from 'react-redux-toastr';

export const initiateLogin = async (data) => {
	try {
		let result = await serviceCalls.post('/api/login', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			const errorMsg = (result?.data && Object.keys(result?.data).length) ? Object.values(result?.data)[0][0] : (result?.error || result?.data?.error || result?.message[0] || "Logged-in failed");
			toastr.error("Login", errorMsg);
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			return result;
		} else {
			return {};	
		}
	} catch (e) {
		return {};
	}
}

export const handleForgotPassword = async (data) => {
	try {
		let result = await serviceCalls.post('/api/forgot_password', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			toastr.error("Forgot Password Failure", result?.data || result?.data?.error || "Forgot password failed");
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			toastr.success("Success", "Please check your email.");
			return result;
		} else {
			return {};	
		}
	} catch (e) {
		return {};
	}
}

export const notifyUser = async (data) => {
	try {
		let result = await serviceCalls.post('/api/notify_user', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			toastr.error("Email notification failed", result?.data || result?.data?.error || "Email sent failed");
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			toastr.success("Success", "Please check your email.");
			return result;
		} else {
			return {};	
		}
	} catch (e) {
		return {};
	}
}

export const requestInfoApi = async (data) => {
	try {
		let result = await serviceCalls.post('/api/request_info', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			toastr.error("Email notification failed", result?.data || result?.data?.error || "Email sent failed");
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			toastr.success("Success", "Please check your email.");
			return result;
		} else {
			return {};	
		}
	} catch (e) {
		return {};
	}
}

export const handleResetPassword = async (data) => {
	try {
		let result = await serviceCalls.post('/api/reset_password', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			toastr.error("Reset Password Failure", result?.error || result?.data?.error || "Reset password failed");
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			return result;
		} else {
			return {};
		}
	} catch (e) {
		return {};
	}
}

export const socialLogin = async (data) => {
	try {
		let result = await serviceCalls.post('/api/social_login', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			const errorMsg = (result?.data && Object.keys(result?.data).length) ? Object.values(result?.data)[0][0] : (result?.error || result?.data?.error || result.data[0] || "Logged-in failed");
			toastr.error("Login", errorMsg);
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			return result;
		} else {
			return {};
		}
	} catch (e) {
		return {};
	}
}

